import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { animate, style, transition, trigger } from '@angular/animations';

export const slideInAnimation = trigger('slideInAnimation', [
  transition(':enter', [
    style({ transform: 'translateX(-100%)' }),
    animate('0.3s ease-in', style({ transform: 'translateX(0%)' })),
  ]),
]);

export const greenInAnimation = trigger('greenInAnimation', [
  transition(':enter', [
    style({ background: 'darkgrey' }),
    animate('4s ease-in', style({})),
  ]),
]);

@Component({
  selector: 'thred-json-viewer',
  standalone: true,
  imports: [CommonModule, NgxJsonViewerModule],
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    slideInAnimation,
    greenInAnimation,
    trigger('blockInitialRenderAnimation', [transition(':enter', [])]),
  ],
})
export class JsonViewerComponent {
  @Input()
  json: unknown[] = [];

  @Input()
  animate = false;

  @Input()
  emptyMessage = 'No data';
}
